/* JOEKR グローバル演出 — カスタムカーソル / Reveal / パララックス / 慣性アンカースクロール */
(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const body = document.body;

  // ---------- カスタムカーソル ----------
  if (matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceMotion) {
    const cursor = document.createElement('div');
    cursor.className = 'j-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    body.appendChild(cursor);

    let x = innerWidth/2, y = innerHeight/2, tx = x, ty = y;
    const lerp = (a, b, n) => a + (b - a) * n;
    let running = false;
    function render() {
      x = lerp(x, tx, 0.28);
      y = lerp(y, ty, 0.28);
      cursor.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
      if (Math.abs(tx - x) < 0.1 && Math.abs(ty - y) < 0.1) { running = false; return; }
      requestAnimationFrame(render);
    }
    addEventListener('mousemove', (e) => {
      tx = e.clientX; ty = e.clientY;
      if (!cursor.classList.contains('is-active')) cursor.classList.add('is-active');
      if (!running) { running = true; requestAnimationFrame(render); }
    });
    document.addEventListener('mouseleave', () => cursor.classList.remove('is-active'));
    const hoverables = 'a, button, [role="button"], .jhero__toggle-img';
    document.addEventListener('mouseover', (e) => {
      if (e.target.closest(hoverables)) cursor.classList.add('is-hover');
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest(hoverables)) cursor.classList.remove('is-hover');
    });
    running = true;
    render();
  }

  // ---------- IntersectionObserver Reveal ----------
  if (!reduceMotion) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    // 画面内（と上方）の要素を先に表示済みにしてから隠すルールを有効化する
    const initReveal = () => {
      // テーマエディタでは再描画されたセクションを observe できないため、隠すルールを有効にしない
      if (window.Shopify && window.Shopify.designMode) return;
      const vh = window.innerHeight;
      document.querySelectorAll('.j-reveal').forEach((el) => {
        if (el.getBoundingClientRect().top < vh) el.classList.add('is-visible');
        else observer.observe(el);
      });
      document.documentElement.classList.add('j-reveal-on');
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReveal);
    } else {
      initReveal();
    }
  }

  // ---------- data-parallax ----------
  if (!reduceMotion) {
    const items = Array.from(document.querySelectorAll('[data-parallax]'));
    if (items.length) {
      let ticking = false;
      const update = () => {
        if (matchMedia('(max-width: 900px)').matches) {
          items.forEach((el) => { el.style.transform = ''; });
          ticking = false; return;
        }
        const vh = innerHeight;
        items.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          const offset = (center - vh/2) * parseFloat(el.dataset.parallax);
          el.style.transform = `translate3d(0, ${-offset}px, 0)`;
        });
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      update();
    }
  }

  // ---------- 慣性アンカースクロール ----------
  if (!reduceMotion) {
    const easeInOutCubic = (t) => t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2, 3)/2;
    const DURATION = 1400;
    const scrollTo = (targetY) => {
      const startY = window.scrollY;
      const distance = targetY - startY;
      const startTime = performance.now();
      const step = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / DURATION, 1);
        window.scrollTo(0, startY + distance * easeInOutCubic(t));
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a || a.classList.contains('skip-to-content-link')) return;
      const href = a.getAttribute('href');
      if (!href || href === '#') return;
      const el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      scrollTo(el.getBoundingClientRect().top + window.scrollY);
    });
  }
})();
